<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<div>
  <form name="form" (ngSubmit)="f.form.valid && register()" #f="ngForm" novalidate>

    <div>
      <div class="container-fluid">
        <div class="row dta_title mar-tb-20 pad-lr-15">
          {{'Usermanagement' | translate}}
        </div>
        <div class="row no-pad mar-btm-100 ">
          <div class="form-group col-md-3 ">
            <label for="firstName">{{'First Name' | translate}}
            </label>
            <input type="text" class="form-control" name="firstName" [(ngModel)]="model.firstName" #firstName="ngModel"
              (ngModelChange)="fnameChange($event)" maxlength="36" />
          </div>
          <div class="form-group col-md-3">
            <label for="lastName">{{'Last Name' | translate}}
            </label>
            <input type="text" class="form-control" name="lastName" [(ngModel)]="model.lastName" #lastName="ngModel"
              (ngModelChange)="lnameChange($event)" maxlength="36" />
          </div>
          <div class="form-group col-md-3">
            <label for="emailId">{{'Email Address' | translate}}
            </label>
            <input type="email" class="form-control" name="email" (ngModelChange)="emailChange(model.emailId)"
              [pattern]="emailPattern" [(ngModel)]="model.emailId" #emailId="ngModel" required />
            <div *ngIf="f.submitted && emailId.errors" class="help-block">
              <div *ngIf="emailId.errors.required">
                {{'Email Address is required' | translate}}.
              </div>
              <div *ngIf="emailId.errors.pattern">
                {{'INVALID_EMAIL' | translate}}
              </div>
            </div>

          </div>
          <div class="form-group col-md-3">
            <label for="phone">{{'Phone Number' | translate}}
            </label>
            <input type="text" class="form-control" name="phonenumber" (ngModelChange)="phoneNumber($event)"
              [(ngModel)]="model.phone" #phone="ngModel" [pattern]="phonePattern" maxlength="17" />
            <div *ngIf="f.submitted && phone.errors" class="help-block">
              <div *ngIf="phone.errors.pattern">
                {{'INVALID_PHONE' | translate}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---row closes here-->
    <div class="container-fluid mar-top-30">
      <div class="row no-pad mar-btm-30">
        <div class="form-group col-md-3">
          <label for="loginId">{{'User Name' | translate}}
          </label>
          <input type="text" class="form-control" name="loginId" [(ngModel)]="model.loginId" #loginId="ngModel"
            disabled />
        </div>
        <div class="form-group col-md-3">
          <label for="emplyoeeName">{{'Company Name' | translate}}
          </label>
          <input type="text" class="form-control" name="companyname" (ngModelChange)="phoneNumber2(model.companyname)"
            [(ngModel)]="model.companyname" #companyName="ngModel" required />
          <div *ngIf="f.submitted && !companyName.valid" class="help-block">{{'Company Name is required' | translate}}</div>
        </div>
        <div class="form-group col-md-3">
          <label for="password">{{'PASSWORD' | translate}}
          </label>
          <input type="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel"
            disabled />
        </div>

        <div class="form-group col-md-3">
          <label for="status">{{'Status' | translate}}
            <span class="required">*</span>
          </label>
          <select name class="form-control" name="status" (ngModelChange)="phoneNumber3(model.status)" [(ngModel)]="model.status"
            #status="ngModel">
            <option value="Active" class="status_review" style="color:green">Active</option>
            <option value="In Active" class="status_review" style="color:red">Inactive</option>
          </select>
        </div>

      </div>
      <!---row closes here-->
    </div>
    <!--container end -->

    <div class="container-fluid mar-top-30">
      <div class="row no-pad mar-btm-30">
        <!-- <div class="form-group col-md-3">
          <label for="userRoleMapping">{{'User Role Mapping' | translate}}
          </label>
          <div class="input-group mb-3">
            <input type="text" class="form-control" name="userrolemapping" [(ngModel)]="model.userrolemapping"
              #userrolemapping="ngModel" disabled>
            <div class="input-group-prepend" *ngIf="isCopyShow">
              <button class="btn btn-outline-secondary pull-right" (click)="cacheUserDetails(cacheDetails)" type="button"><i
                  class="fa fa-copy"></i></button>
            </div>
          </div>
        </div> -->
        <div class="form-group col-md-4">
            <label for="userRoleMapping">{{'User Role Mapping' | translate}}
                <span class="required">*</span>
            </label>
            <div class="input-group mb-3">
                <ng-multiselect-dropdown class="col-md-3" [settings]="userRoleSettings" [data]="userDataRolesList"
                name="userRolesList" (onSelect)="onRoleItemSelect($event)"  [(ngModel)]="model.userRolesList" 
                (onDeSelect)="OnRoleItemDeSelect($event)" (onSelectAll)="onRoleSelectAll($event)" (onDeSelectAll)="onRoleDeSelectAll($event)">
              </ng-multiselect-dropdown>
              <div class="input-group-prepend" *ngIf="isCopyShow">
                <button class="btn btn-outline-secondary pull-right" (click)="cacheUserDetails(cacheDetails)" type="button"><i
                    class="fa fa-copy"></i></button>
              </div>
            </div>
          </div>
          <!-- <div class="form-group col-md-3">
            <label for="userRoleMapping">{{'Operations Type' | translate}}</label>
          <select class="form-control" required [(ngModel)]="operationType" name="operationType"
           placeholder="Select Operation Types" (change)="onOperationTypeSelect($event)">
            <option *ngFor="let op of operationTypes" [value]="op.value" [selected]="op.value === userOperationType">{{op.displayName}}</option>
          </select>
        </div> -->
        <div class="form-group col-md-4" *ngIf="operationTypeDropdown">
          <label for="operationType">{{'Operations Type' | translate}}<span class="required">*</span></label>
          <select name class="form-control" name="operationType" [(ngModel)]="model.operationType" #operationType="ngModel" (ngModelChange)="onOperationTypeSelect($event)">
            <option value="Select">Select</option>
            <option value="Supplier To Supplier">Supplier To Supplier</option>
            <option value="Fuso Operations">Fuso Operations</option>
            <!-- <option *ngFor="let op of operationTypes" [value]="op.value" [selected] = "op.displayName === userOperationType">{{op.displayName}}</option>I -->
          </select>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <!--
          <div class="col-md-12" *ngIf="(model.linenumber == null || model.linenumber.length == 0)" [hidden]="model.userrolemapping == 'l4Manager' || model.userrolemapping == 'LSP'">
          <label for="Supplier codes">{{'SUPPLIERCODE' | translate}}</label>
          <ng-multiselect-dropdown class="col-md-3" *ngIf="model.userrolemapping !=  'Supplier'  " [data]="suppCodeList"
            name="supplierCode" [(ngModel)]="model.supplierCode" [settings]="suppCodesettings" (ngModelChange)="valuechangeSupplierCode($event)">
          </ng-multiselect-dropdown>

          <ng-multiselect-dropdown class="col-md-3" *ngIf="model.userrolemapping == 'Supplier' " [data]="suppCodeList"
            name="supplierCode" [(ngModel)]="model.supplierCode" [settings]="suppCodesettings2" (ngModelChange)="valuechangeSupplierCode($event)">
          </ng-multiselect-dropdown>
        </div>
        -->
        <div class="col-md-4" *ngIf="!(model.supplierCodeRawUpdate.length == 0) ||  suppliercodeDropdown" [hidden]="model.userrolemapping == 'l4Manager' || model.userrolemapping == 'LSP'">
          <label for="Supplier codes">{{'SUPPLIERCODE' | translate}}</label>
          <ng-multiselect-dropdown class="col-md-3"  [settings]="suppCodesettings" [data]="suppCodeList"
            name="supplierCode" [(ngModel)]="model.supplierCode" (ngModelChange)="valuechangeSupplierCode($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class=" col-md-4 mar-rgt-20" *ngIf="nextProcessRequired || (model.lineNumbers && model.lineNumbers.length !== 0)">
          <label for="lineNumbers">{{'LINENUMBER' | translate}}
          </label>
          <ng-multiselect-dropdown *ngIf="lineCodeList" [settings]="lineNumbersettings"
           [(ngModel)]="model.lineNumbers" name="lineNumbers" [data]="lineCodeList"
             (ngModelChange)="valuechange($event)">
          </ng-multiselect-dropdown>
        </div>

        <div class=" col-md-4 mar-rgt-20" *ngIf="showOPMSupplierCode && deliveryPointCheck">
          <label for="Supplier codes">Delivery Point for Operation Manager
          </label>
          <ng-multiselect-dropdown  [settings]="supplierCodeOpmsettings" [(ngModel)]="model.deliveryPoint" name="deliveryPointOpm" [data]="deliveryPointList"
            (ngModelChange)="valuechangeDeliveryPointOPM($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row  mar-btm-30">
        <div class="form-group  col-md-2 mar-rgt-20" *ngIf="model.linenumber == null" [hidden]="model.userrolemapping != 'l4Manager'">
          <label for="SMQ">{{'SM' | translate}}
          </label>
          <ng-multiselect-dropdown   [settings]="SMQSettings"[ngModelOptions]="{standalone: true}" *ngIf="SMQUsers" [(ngModel)]="model.SMQ" name="SMQ"
            [data]="SMQUsers" (ngModelChange)="valuechangeSMQ($event)">
            <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item>
          </ng-multiselect-dropdown>
        </div>

        <div class="form-group  col-md-2 mar-rgt-20" *ngIf="model.linenumber == null" [hidden]="model.userrolemapping != 'l4Manager'">
          <label for="SMVS">{{'SM-VS' | translate}}
          </label>
          <ng-multiselect-dropdown  [settings]="SMVSSettings"  [ngModelOptions]="{standalone: true}" *ngIf="SMVSUsers" [(ngModel)]="model.SMVS" name="SMVS"
            [data]="SMVSUsers" (ngModelChange)="valuechangeSMVS($event)">
            <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item>
          </ng-multiselect-dropdown>
        </div>

        <div class="form-group  col-md-2 mar-rgt-20" *ngIf="model.linefnumber == null" [hidden]="model.userrolemapping != 'l4Manager'">
          <label for="Logistics">{{'LOGISTICS' | translate}}
          </label>
          <ng-multiselect-dropdown [settings]="LogisticsSettings" [ngModelOptions]="{standalone: true}" *ngIf="LogisticsUsers" [(ngModel)]="model.Logistics"
            name="Logistics" [data]="LogisticsUsers"  (ngModelChange)="valuechangeLogistics($event)">
            <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item>
          </ng-multiselect-dropdown>
        </div>

        <div class="form-group  col-md-2 mar-rgt-20" *ngIf="model.linenumber == null" [hidden]="model.userrolemapping != 'l4Manager'">
          <label for="operations">{{'OPERATIONS' | translate}}
          </label>
          <ng-multiselect-dropdown [settings]="operationsSettings" [ngModelOptions]="{standalone: true}" *ngIf="operationsUsers" [(ngModel)]="model.Operations"
            name="operations" [data]="operationsUsers"  (ngModelChange)="valuechangeOperations($event)">
            <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item>
          </ng-multiselect-dropdown>
        </div>
      </div>
    </div>
    <div class="form-group text-center ">
      <button [disabled]="userIDTaken || savedisabledSMADmin || userAccess" type="submit" value="Register" class="btn btn-primary black">{{'SAVE'
        | translate}}</button>
      <a [routerLink]="['/um']" class="btn btn-primary black">{{'CANCEL' | translate}}</a>
    </div>

  </form>
</div>

<ng-template #cacheDetails let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Copy selelcted user details</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h5 *ngIf="model.userrolemapping === 'l4Manager'">Do you want to copy the user role for new registration</h5>
    <h5 *ngIf="model.userrolemapping !== 'l4Manager'">Do you want to copy the user role & <b class="text-normal" *ngIf="model.userrolemapping == 'Operation'">Next
        Process</b>
      <b class="text-normal" *ngIf="model.userrolemapping != 'Operation'">supplier code</b>
      for new registration</h5>
  </div>
  <div class="modal-footer">
    <button type="button" class="col-md-2  btn btn-dark" (click)="replicaCurrentUser()">{{'Yes' | translate}}</button>
    <button type="button" class="col-md-2 btn btn-outline-dark" (click)="close()">{{'No' | translate}}</button>
  </div>
</ng-template>


<!--User Details Updation confirmation Modal -->

<ng-template #userUpdation let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Success</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p> {{'USER_DETAIL_UPDATED' | translate}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn btn-dark" (click)="close()">Ok</button>
  </div>
</ng-template>